const domainName = "https://pv-admin-test.pro-vigil.us/api";
const domainNameForMasking = "https://apps.pro-vigil.us:9096/api/";
const camServerBaseUrl = 'https://profit-cs-test.pro-vigil.us';
const workSpaceDomain = "https://apps.pro-vigil.us:9051/api";
const restrictUserDomain = "https://galaxy-test.pro-vigil.info:8443/galaxy/api";
const userActivityAPI = 'https://pvportal.pro-vigil.us:8082/useractivity/';
const cfCheckerAPI = 'https://portal-uat.pro-vigil.info:8901';

export const environment = {
  production: false,
  // ga: 'G-NJZKZ6DNC6',
  ga: 'G-V6LYRJDP7T',
  baseUrl: domainName,
  baseUrlForMasking : domainNameForMasking,
  camServerAPI: `${camServerBaseUrl}:9119/api/`,
  camServerLiveViewAPI: `${camServerBaseUrl}:9006/api/`,
  camServerAlarmAPI: `${camServerBaseUrl}:9005/api/`,
  camServerDayNightImageSync: `${camServerBaseUrl}:9007/api/`,
  footageDownload: `${camServerBaseUrl}:8084/api/`,
  releaseVersion: '8.0',
  workSpaceAPI: workSpaceDomain,
  restrictUserDomain: restrictUserDomain,
  userActivityAPI,
  cfCheckerAPI,
  env: 'test',
  GOOGLE_CLIENT_ID: '138155935175-mcvi6soulletoaeb9og4ggtr5b96k0lk.apps.googleusercontent.com',
  FEATURE_FLAG : {
    cameraServer: true,
    axisMetadata: false,
    masking: true,
    ec2: true,
    liveView: false,
    footageDownload: true,
    isIcockpit: false,
    isCameraSetting: true,
    cpLogs: true,
    userMgmt: true
  }
};